<template>
  <LogMessage :text="logTrace" />
</template>

<script>
import { mapGetters } from 'vuex'
import LogMessage from './LogMessage.vue'

export default {
  components: { LogMessage },
  computed: {
    ...mapGetters({
      logTrace: 'logs/currentLogTrace',
    }),
  },
}
</script>
